import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

// PATCH API for editing a page
export const pageEditApi = createAsyncThunk(
    'auth/pages/edit',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.patch(apiRoutes.adminAction(`${data.page}`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

// POST API for creating a page
export const pagePostApi = createAsyncThunk(
    'auth/pages/post',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(apiRoutes.adminAction(`${data.page}`, 1), data)
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

// Cleanup action
export const cleanupPageEdit = createAction('pageEdit/cleanup')

const initialState = { result: [], loading: false, error: null, message: "" }

const pageEditSlice = createSlice({
    name: 'page Edit',
    initialState,
    extraReducers: (builder) => {
        // PATCH
        builder.addCase(pageEditApi.pending, (state) => {
            state.loading = true
        })
        builder.addCase(pageEditApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(pageEditApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
        // POST
        builder.addCase(pagePostApi.pending, (state) => {
            state.loading = true
        })
        builder.addCase(pagePostApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(pagePostApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
        builder.addCase(cleanupPageEdit, (state) => {
            state.result = []
            state.loading = false
            state.error = null
            state.message = ""
        })
    },
})

export const pageEditReducer = pageEditSlice.reducer